import { render, staticRenderFns } from "./xlDiaresPage.vue?vue&type=template&id=68740368&scoped=true"
import script from "./xlDiaresPage.vue?vue&type=script&lang=js"
export * from "./xlDiaresPage.vue?vue&type=script&lang=js"
import style0 from "./xlDiaresPage.vue?vue&type=style&index=0&id=68740368&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68740368",
  null
  
)

export default component.exports